import styled from 'styled-components';

// Standard Column
export const StyledColumn = styled.div<{width?: string}>`
    width: ${props=> props.width? props.width : '50%'};
    display: flex;
    flex-direction: column;
    justify-content: center
`;

